'use-client';
import * as React from 'react';
import classNames from 'clsx';
import { getDataAttributes } from '@wix/editor-elements-common-utils';
import type { IFacebookLikeBoxProps } from '../FacebookLikeBox.types';
import { TestIds } from '../constants';
import { useFacebookLikeBox } from '../../../providers/useFacebook/useFacebook';
import { getComponentProps } from '../../ConsentPolicyWrapper/viewer/utils';
import style from './style/FacebookLikeBox.scss';

const FacebookLikeBox: React.FC<IFacebookLikeBoxProps> = props => {
  const {
    id,
    className,
    href,
    currentHeight,
    width,
    showHeader,
    showStream,
    showFaces,
    language,
    isConsentPolicyActive,
    onMouseEnter,
    onMouseLeave,
  } = props;

  const ref = useFacebookLikeBox({ language });

  const baseComponentProps = getComponentProps(isConsentPolicyActive, {
    id,
    className: classNames(style.container, className),
    ...getDataAttributes(props),
  });

  return (
    <div
      {...baseComponentProps}
      key={href}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      ref={ref}
    >
      <div
        className="fb-page"
        data-href={href}
        data-width={width}
        data-height={currentHeight}
        data-show-posts={showStream}
        data-hide-cover={!showHeader}
        data-show-facepile={showFaces}
        data-adapt-container-width={true}
        data-testid={TestIds.fbPageEl}
      />
    </div>
  );
};

export default FacebookLikeBox;
